const getDiagnosticReportStudyId = diagnosticReport =>
	diagnosticReport?.imagingStudy?.find(d => d?.reference?.toLowerCase()?.includes('imagingstudy'))?.id;

export default getDiagnosticReportStudyId;
